import { Moment } from 'moment';

import { LegalEntity } from './legal-entity.model';

/**
 * Model for API CustomerEstablishment Model
 */
export class Establishment {
  /**
   * technical ID
   */
  id: number;

  /**
   * Establishment unique code. siret
   */
  code: string;

  /**
   * Legal entity owning this Establishment.
   */
  legalEntity: LegalEntity;

  /**
   * 1 if establishment is a Headquarter, 0 if not
   */
  siege: number;

  /**
   * Commercial name
   */
  commercialName: string;

  /**
   * Establishment commune
   */
  libcom: string;

  /**
   * Establishment address
   */
  address: string;

  /**
   * Main activity code of Establishment
   */
  activityCode: string;

  /**
   * Main activity label of Establishment
   */
  activityLabel: string;

  /**
   * Postal code
   */
  postalCode: string;

  /**
   * Repetition index
   */
  repetitionIndex: string;

  /**
   * VAT
   */
  vat: string;

  /**
   * Road type for Establishment address
   */
  roadType: string;

  /**
   * Road number
   */
  roadNumber: string;

  /**
   * Road name
   */
  roadName: string;

  /**
   * CEDEX
   */
  cedex: string;

  validityStartDate: Moment;

  validityEndDate: Moment;

  constructor(attributes: Partial<Establishment> = {}) {
    Object.assign(this, attributes, { address: attributes['address'] || '' });
  }
}
